import React, { Component } from 'react';
// import './supportingFoundations.scss';
export default class SupportingFoundations extends Component {
	render() {
		return (
			<div className="sf-container">
				<div className="sf-wrapper container">
					<div className="sf-logo">
						<div className="sf-list-wrapper">
						<img
								// src={
								// 	'https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/homeTempv1/supporting-foundations-v2.png'
								// }
								src="https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/supporting-foundations-greyscale-v3.jpg"
								alt="supporting-foundation"
								loading="lazy"
							/>
						</div>
					</div>
					<div className="sf-content-panel">
						<div className="sf-content">
							<h2>Foundations</h2>
							<div className="sf-hr"></div>
							<p>
								Trusted by the largest and most impactful foundations worldwide
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
